import { useState, useEffect } from "react";
import { api, apiError } from "@/api";

const POPUP_KEY = "ank_popup_dismissed";
const DELAY_MS = 3000;

export default function EmailPopup() {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [honeypot, setHoneypot] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(POPUP_KEY)) return undefined;
    const timer = setTimeout(() => {
      setVisible(true);
      try { window.posthog?.capture("popup_shown"); } catch {}
    }, DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(POPUP_KEY, "1");
    setVisible(false);
  };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/popup-subscribe", { email, website: honeypot });
      try { window.posthog?.capture("popup_signup_complete"); } catch {}
      sessionStorage.setItem(POPUP_KEY, "1");
      setDone(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  if (!visible) return null;

  return (
    <div className="pop-veil" data-testid="popup-veil" onMouseDown={(e) => e.target === e.currentTarget && dismiss()}>
      <div className="pop-card" role="dialog" aria-modal="true" aria-label="Join the community" data-testid="email-popup">
        <button type="button" className="pop-close" onClick={dismiss} aria-label="Close" data-testid="popup-close-btn">
          ✕
        </button>
        {done ? (
          <div className="pop-done" data-testid="popup-success">
            <p className="pop-headline">YOU'RE IN.</p>
            <p className="pop-sub">See you on the dancefloor. 🖤</p>
          </div>
        ) : (
          <>
            <span className="pop-tag" data-testid="popup-tag">JOIN THE COMMUNITY</span>
            <h3 className="pop-headline" data-testid="popup-headline">STAY IN THE LOOP</h3>
            <p className="pop-sub" data-testid="popup-subtext">
              New sessions, events, and announcements — straight to your inbox.
            </p>
            <form onSubmit={submit} className="pop-form" data-testid="popup-form">
              <input
                type="text"
                value={honeypot}
                onChange={(e) => setHoneypot(e.target.value)}
                className="ank-honeypot"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
              />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="pop-input"
                data-testid="popup-email-input"
                aria-label="Email address"
              />
              {error && <p className="ank-form-error" data-testid="popup-error">{error}</p>}
              <button type="submit" className="pop-cta" disabled={busy} data-testid="popup-submit-btn">
                {busy ? "SUBSCRIBING…" : "SUBSCRIBE →"}
              </button>
            </form>
            <button type="button" className="pop-dismiss" onClick={dismiss} data-testid="popup-dismiss-btn">
              No thanks, keep browsing
            </button>
          </>
        )}
      </div>
    </div>
  );
}
